



























import { Component, Vue } from "vue-property-decorator";
import ParkingStats from "@/components/ParkingStats.vue";
import LoginForm from "@/auth/LoginForm.vue";
import "./global";
import parkingRepository from "@/data/parkingRepository";
import { globalState } from '@/globalState';
import LogoImg from "@/components/LogoImg.vue";

@Component({
  components: {
    ParkingStats,
    LoginForm,
    LogoImg
  }
})
export default class App extends Vue {
  minLoadingTimeElapsed = false;
  bootstrapped = false;

  mounted() {
    this.updateParkingStats().finally(() => {
      this.bootstrapped = true;
    })
    setTimeout(() => {
      this.minLoadingTimeElapsed = true;
    }, 500);
  }

  updateParkingStats() {
    return parkingRepository.getStats().then(res => {
      globalState.updateStats(res);
      globalState.isLoggedIn = true;
    })
  }

  get isLoggedIn() {
    return globalState.isLoggedIn;
  }

  get bootstrapping() {
    return !this.bootstrapped || !this.minLoadingTimeElapsed;
  }
}
